import { Dispatch, FC, SetStateAction } from 'react';
import styled from 'styled-components';
import { PLACEHOLDER_IMAGE } from '../../../../api/baseURL';
import delete_icon from '../../../../assets/delete_icon.svg';
import { Carousel } from '../../../../component/carousel';
import { IStoreProduct } from '../../../../store/shopping/interface';
import { pxToRem } from '../../../../utils/pxToRem';

type IStoreProductCard = {
  product: IStoreProduct;
  handleEdit: Dispatch<SetStateAction<IStoreProduct | null>>;
  handleDeleteStoreProduct: (id: string) => void;
};
export const StoreProduct: FC<IStoreProductCard> = ({
  product,
  handleEdit,
  handleDeleteStoreProduct
}) => {
  return (
    <Card onClick={() => handleEdit(product)}>
      <CustomCarousel
        images={
          product.file.length ? product.file : [{ url: PLACEHOLDER_IMAGE }]
        }
      />
      <DeleteBtn>
        <Icon
          src={delete_icon}
          onClick={(e) => {
            handleDeleteStoreProduct(product._id);
            e.stopPropagation();
          }}
        />
      </DeleteBtn>
      <ProductDetailContainer>
        <ProductDetail>{product.name}</ProductDetail>
        <ProductDetail>{`N${product.price}`}</ProductDetail>
      </ProductDetailContainer>
      <NumberOfProducts>{`Stock : ${product.stock}`}</NumberOfProducts>
    </Card>
  );
};

const Card = styled.div`
  background: #ffffff;
  box-shadow: 0px 5.11803px 5.11803px rgba(50, 50, 71, 0.08),
    0px 5.11803px 10.2361px rgba(50, 50, 71, 0.06);
  border-radius: 8px;
  position: relative;
  padding: 8px 8px 16px 8px;
  width: calc(33.33% - 36px);
  max-height: 218px;
  margin: 0px 10px;
  margin-bottom: 28px;
  @media (max-width: 1000px) {
    width: calc(50% - 36px);
  }
  @media (max-width: 730px) {
    width: 100%;
    margin: 0;
    margin-bottom: 28px;
  }
`;
const CustomCarousel = styled(Carousel)`
  height: 120px;
`;
const DeleteBtn = styled.button`
  position: absolute;
  z-index: 1;
  right: 24px;
  top: 16px;
  background-color: transparent;
  outline: none;
  border: none;
  padding: 0;
  & :hover {
    opacity: 0.6;
  }
`;
const Icon = styled.img`
  max-height: 28px;
  max-width: 28px;
`;

const ProductDetailContainer = styled.div`
  margin: 12px 0px 8px 0px;
  display: flex;
  justify-content: space-between;
`;
const ProductDetail = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: ${pxToRem(12)};
  line-height: ${pxToRem(14)};
  text-transform: capitalize;
`;

const NumberOfProducts = styled.p`
  font-weight: bold;
  font-size: ${pxToRem(8)};
  line-height: 120%;
  align-self: flex-end;
  text-align: right;
  letter-spacing: 0.5px;
  text-transform: capitalize;
  color: #a1a1a1;
  margin-bottom: 16px;
`;
